<template>
  <div>
    <!-- <div>首页</div> -->
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
    <!-- <tabbar
      v-model="active"
      active-color="#4FD9D5"
      inactive-color="#888888"
      @change="onChange"
      style="height:60px"
    >
      <tabbar-item name="home">
        <span>首页</span>
        <template #icon="props">
          <img
            class="table-icon-img"
            :src="
              props.active
                ? require('../../assets/tabbaricon/home_onpress.png')
                : require('../../assets/tabbaricon/home.png')
            "
          />
        </template>
      </tabbar-item>
      <tabbar-item name="zx" icon="search">
        <span>咨询</span>
        <template #icon="props">
          <img
            class="table-icon-img"
            :src="
              props.active
                ? require('../../assets/tabbaricon/zx_onpress.png')
                : require('../../assets/tabbaricon/zx.png')
            "
          />
        </template>
      </tabbar-item>
      <tabbar-item name="sq" icon="friends-o">
        <span>社区</span>
        <template #icon="props">
          <img
            class="table-icon-img"
            :src="
              props.active
                ? require('../../assets/tabbaricon/sq_onpress.png')
                : require('../../assets/tabbaricon/sq.png')
            "
          />
        </template>
      </tabbar-item>
      <tabbar-item name="msg" :badge="msgNum == 0 ? '' : msgNum" icon="setting-o">
        <span>消息</span>
        <template #icon="props">
          <img
            class="table-icon-img"
            :src="
              props.active
                ? require('../../assets/tabbaricon/msg_onpress.png')
                : require('../../assets/tabbaricon/msg.png')
            "
          />
        </template>
      </tabbar-item>
      <tabbar-item :name="mine" icon="setting-o">
        <span>我的</span>
        <template #icon="props">
          <img
            class="table-icon-img"
            :src="
              props.active
                ? require('../../assets/tabbaricon/mine_onpress.png')
                : require('../../assets/tabbaricon/mine.png')
            "
          />
        </template>
      </tabbar-item>
    </tabbar> -->
    <!-- <div class="lien"></div> -->
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-12
@create:wq
*/

import { Tabbar, TabbarItem } from "vant";
export default {
  name: "home",
  props: {},
  components: { Tabbar, TabbarItem },
  data() {
    return {
      active: "home",
      mine: "mine",
      msgNum: this.$store.getters.msgNum,
    };
  },
  computed: {},
  watch: {
    $route: "getPath",
    "$store.state.app.msgNum": {
      handler: function(newVal) {
        this.msgNum = newVal;
      },
      deep: true,
    },
  },
  mounted() {},
  created() {
    this.active = this.$route.name;
    // console.log(JSON.parse(localStorage.getItem("user")).is_teacher);
    const user =
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user")).is_teacher == 1
        ? true
        : false;
    if (user) {
      this.mine = "tmine";
    }
  },
  methods: {
    getPath() {
      // console.log(this.$route.path);
      let path = this.$route.path;
      if (path == "/tmine" || path == "/mine") {
        this.active = path.substring(1);
      }
    },
    onChange(e) {
      // console.log(this.active);
      // if (e == this.active) return;
      switch (e) {
        case "home":
          this.$router.replace({ path: "/home" });
          break;
        case "zx":
          this.$router.replace({ path: "/zx" });
          break;
        case "sq":
          this.$router.replace({ path: "/sq" });
          break;
        case "msg":
          this.$router.replace({ path: "/msg" });
          break;
        case "mine":
          this.$router.replace({ path: "/mine" });
          break;
        case "tmine":
          this.$router.replace({ path: "/tmine" });
          break;
      }
    },
    
  },
};
</script>
<style scoped>
.lien {
  height: 100px;
}
.table-icon-img {
  width: 0.45rem;
  height: 0.45rem;
}
</style>
